import React, { Component } from 'react';
import NotaFiscalCteOs from './NotaFiscalCteOs';
import { withRouter, Link } from 'react-router-dom';
import ReactToPrint from 'react-to-print';
import buscarEmissaoCteOSNotaFiscal from '../../actions/cteos/buscarEmissaoCteOSNotaFiscal';
import { connect } from 'react-redux';
import qs from 'qs';
import { PERFIL_ADMIN, getAdminEmpresa, getGestorEmpresa } from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import JsBarcode from 'jsbarcode';

class PainelNotaFiscalCteOs extends Component {

    constructor(props) {
        super(props);

        this.state = {
            referenciaSelecionada: null
        }
    }

    componentDidMount() {
        setTimeout(() => JsBarcode('.barcode2').init(), 1300);
        
        const parametros = qs.parse(this.props.history.location.search, { ignoreQueryPrefix: true });
        if (parametros.cteos) {
            this.setState({
                referenciaSelecionada: React.createRef()
            });

            this.props.buscarEmissaoCteOSNotaFiscal(parametros.cteos, this.props.empresaSelecionada.id);
        } else {
            this.props.history.push('/painel-cte-os')
        }
    }

    recuperarNomeArquivo() {
        return 'nota-fiscal'
    }

    exibirBotoes() {
        return (
            <React.Fragment>
                <Link className="mt-4 ml-2 mr-4" to="/painel-cte-os">
                    <button className='btn btn-laranja'>Concluir</button>
                </Link>
                <ReactToPrint
                    trigger={() => <button disabled={!this.state.referenciaSelecionada}
                        className="btn btn-laranja">IMPRIMIR
                    </button>}
                    content={() => document.querySelector('#notaFiscalCteOs')}
                    documentTitle={this.recuperarNomeArquivo()}
                />
            </React.Fragment>
        )
    }

    render() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN, getAdminEmpresa(this.props.empresaSelecionada.id),
                getGestorEmpresa(this.props.empresaSelecionada.id)]}>
                {this.exibirBotoes()}
                <NotaFiscalCteOs ref={this.state.referenciaSelecionada} />
                {this.exibirBotoes()}
            </Autorizacao>
        )
    }
}


export const mapStateToProps = state => (
    {
        empresaSelecionada: state.empresaSelecionada,
    });

export default withRouter(connect(mapStateToProps,
{
    buscarEmissaoCteOSNotaFiscal
})(PainelNotaFiscalCteOs))